export enum ApplicationKind {
  HTTP = 'http',
  GRPC = 'grpc',
  ElasticSearch = 'elasticsearch',
  Kafka = 'kafka',
  RabbitMQ = 'rabbitmq',
  PostgreSQL = 'postgresql',
  MySQL = 'mysql',
  Redis = 'redis',
  Zookeeper = 'zookeeper',
  Prometheus = 'prometheus',
}
